<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex';

export default {
    init: async(payload) => {
        

        let response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)).data;
        payload.user = response.result;
        payload.dataCompany = response.result;
        payload.user.serviceTypes = response.result.companyUser.company.typeService;
        payload.company = payload.$session.get('user').companyUser.company._id;
        
        if(payload.user){
            if(payload.user.isAcceptGeneralTerms == false)
            {
                $('#modalTerm').modal('toggle'); 
            }
            else
            if(payload.user.isAcceptPurchaseTerms == false)
            {
                let service = payload.user.serviceTypes[0];
                    console.log(service);
                    if(service == "PART_SUPPLIER")
                    {
                        $('#modalTermParts').modal('toggle'); 
                    }
                    if(service == "CERTIFIER")
                    {
                        $('#modalTermCertifies').modal('toggle'); 
                    }
                    if(service == "SERVICE_PROVIDER")
                    {

                        $('#modalTermServices').modal('toggle'); 
                    }
            }
            if(payload.user.isAcceptGeneralTerms == true && payload.user.isAcceptPurchaseTerms == true)
            {
                const el = document.body;
                el.removeAttribute("class");
                $('.modal').modal('hide');
            }  
        }
      
    },
    methods:{
     
        hasType: function(type){
            if (this.user){
                return this.user.serviceTypes.findIndex(x => x == type) > -1;
            }else{
                return false;
            }
        },
        acceptedTermGeneral: function(resp){
            if (resp==1){
                console.log(this.data.email);
                Request.do(this, 'PUT', Request.getDefaultHeader(this), {isAcceptGeneralTerms:true}, `${Endpoints.systemUsers.updateTerms}${this.user.email}`,
                (response)=>{//SUCCESS CALLBACK
                     if(this.user.isAcceptPurchaseTerms == false)
                    {
                        let service = this.user.serviceTypes[0];
                        console.log(service);
                        if(service == "PART_SUPPLIER")
                        {
                            $('#modalTermParts').modal('toggle'); 
                        }
                        if(service == "CERTIFIER")
                        {
                            $('#modalTermCertifies').modal('toggle'); 
                        }
                        if(service == "SERVICE_PROVIDER")
                        {
                            $('#modalTermServices').modal('toggle'); 
                        }
            
                    }
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                    }
                    console.log(JSON.stringify(error));
            });

            }
            else{
                  this.$router.push({ path: '/logout' });
            }
        },
        acceptedTermPurchase: function(response){
            if (response==1){
                Request.do(this, 'PUT', Request.getDefaultHeader(this), {isAcceptPurchaseTerms: true},  `${Endpoints.systemUsers.updateTerms}${this.user.email}`,
                 (companyResponse)=>{//SUCCESS CALLBACK
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }
                    }
                    console.log(JSON.stringify(error));
            });

            }
            else{
                this.$router.push({ path: '/logout' });
            }
        },
          

    }
 
}
</script>
